import { EllipsisOutlined } from '@ant-design/icons';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import Button from 'app/components/Button';
import Dropdown from 'app/components/Dropdown';
import React from 'react';
import withApplicable from '../HOCs/withApplicableOption';
import { compose } from 'app/utils';
import classes from './Styles/Dropdown.module.scss';

export type DropdownMenuOptionType = ItemType & {
  isApplicable?: (record: any) => boolean;
};

type DropdownMenuCellProps = {
  options: ItemType[];
};

function DropdownMenuCell(props: DropdownMenuCellProps) {
  return (
    <Dropdown
      className={classes.dropdownMenuCell}
      overlayClassName={classes.dropdownMenuCellOverlay}
      placement="bottomLeft"
      arrow
      menu={{ items: props.options }}
    >
      <Button type="text" icon={<EllipsisOutlined />}></Button>
    </Dropdown>
  );
}

export default compose(withApplicable)(DropdownMenuCell);
